



















































import Vue from "vue";
import RestClient, { RestError } from "../RestClient";

import AppFrame from "../components/general/AppFrame.vue";
import Loading from "../components/general/Loading.vue";

import Rental from "../components/rental/public/Rental.vue";

import { SettingsPublicJson } from "../shared/SettingsJson";
import RentalBookingInfoJson from "../shared/RentalBookingInfoJson";

import ClientJson from "../shared/ClientJson";
import CategoryTypeJson from "../shared/CategoryTypeJson";

import CustomContent from "../components/custom/RentalRegistration";

export default Vue.extend({
  name: "verleih",
  components: {
    AppFrame,
    Rental,
    Loading,
  },
  data() {
    return {
      RestClient: RestClient,
      CustomContent: CustomContent,
      settings: null as SettingsPublicJson | null,
      currentPageComponent: "Rental" as string | null,
      currentPageTitle: "Verleih",
      childHasChanges: false as boolean,
      appFrameButtons: null as object | null,
      appFrameClickedButton: null as object | null,
      reload: null as Date | null,
      rentalBookingInfo: null as RentalBookingInfoJson | null,
      clientData: undefined as ClientJson | null | undefined,
      clientPassword: null as string | null,
      restrictToTypeId: null as number | null,
      cartAmount: 0 as number,
    };
  },
  created() {
    this.initRental();
  },
  methods: {
    async initRental() {
      await this.loadPublicSettings();
      await this.loadRentalBookingInfo();
    },

    async loadPublicSettings() {
      this.settings = null;

      let rc = RestClient;
      try {
        this.settings = await rc.getPublicSettings();
      } catch (e) {
        alert(e.message);
      }
    },

    async loadRentalBookingInfo() {
      this.rentalBookingInfo = null;

      let rc = RestClient;
      try {
        this.rentalBookingInfo = await rc.getRentalBookingInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    changePage(component: string, title: string): void {
      if (this.childHasChanges) {
        let c = confirm("Es gibt Eingaben, die noch nicht gespeichert wurden. Wollen Sie wirklich fortfahren?");
        if (c == true) {
          this.childHasChanges = false;
          this.currentPageComponent = null;

          this.$nextTick(() => {
            this.currentPageComponent = component;
            this.currentPageTitle = title;
            this.appFrameButtons = null;
            //this.showSidebar = false
          });
        } else {
          //do nothing
        }
      } else {
        this.currentPageComponent = null;

        this.$nextTick(() => {
          this.currentPageComponent = component;
          this.currentPageTitle = title;
          this.appFrameButtons = null;
          //this.showSidebar = false
        });
      }
    },

    setLoggedInClient(clientData: ClientJson, password: string) {
      this.clientData = clientData;
      this.clientPassword = password;
    },

    setChildHasChanges(changes: boolean): void {
      this.childHasChanges = changes;
    },

    appFrameButtonsToShow(buttons: Object) {
      this.appFrameButtons = buttons;
    },

    appFrameButtonClicked(button: Object) {
      this.appFrameClickedButton = button;
    },

    setCartAmount(amount: number) {
      this.cartAmount = amount;
    },
  },
  watch: {},
});
